import React from 'react';
import { useLocation } from 'react-router-dom';
import { getSiteConfig } from '../libs/common/siteConfig';
import { getEventMetadata } from '../libs/common/eventLibrary';
import { getThemeColors } from '../libs/common/themeConfig';
import { useTranslation } from '../libs/common/i18n';
import { useEventLibrary } from './EventLibrary';

export const EventSelector = () => {
  const { pathname } = useLocation();
  const { open, setOpen, trigger } = useEventLibrary();
  const { t } = useTranslation();
  const colors = getThemeColors();
  const event = getEventMetadata(getSiteConfig().type)[pathname];
  return <button ref={trigger} type="button" onClick={() => setOpen(!open)}
    aria-expanded={open} aria-controls="event-library" aria-label={t('eventLibrary')}
    className="event-selector-button flex items-center gap-2 px-3 py-2 rounded w-full text-left min-h-[2.5rem]"
    style={{ backgroundColor: colors.background, border: `1px solid ${colors.border}`, color: colors.text }}>
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeWidth="2" d="M3 5h18M3 12h18M3 19h18M8 5v14" /></svg>
    <span className="event-selector-current-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, fontSize: 14 }}>{event?.name || t('eventLibrary')}</span>
    <span className="event-selector-current-compact">{t('eventLibrary')}</span>
  </button>;
};
